import React from 'react';

import { ChangeStep } from '../../changeModalSteps';

export interface WizardStepProps {
  name: ChangeStep;
  skip?: boolean;
  children: React.ReactNode;
}

const WizardStep: React.FC<WizardStepProps> = ({ children }) => <>{children}</>;

export default WizardStep;
